import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from 'react-router-dom';
var UpdateAppointment = function () {
    var id = useParams().id;
    return (_jsx(Navigate, { to: "/appointments/".concat(id), replace: true, state: { editAppointment: true } }));
};
export default UpdateAppointment;
